import { useEffect, useState } from 'react';

const parseStat = (value) => {
  const match = value.match(/^(\d+(?:\.\d+)?)(.*)$/);
  if (!match) return { num: null, suffix: value, decimals: 0 };
  const numStr = match[1];
  const decimals = numStr.includes('.') ? numStr.split('.')[1].length : 0;
  return { num: parseFloat(numStr), suffix: match[2], decimals };
};

export const useCountUp = (value, active, duration = 1200) => {
  const { num, suffix, decimals } = parseStat(value);
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!active || num === null) {
      setDisplay(value);
      return undefined;
    }

    let start = null;
    let frame;

    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const eased = 1 - (1 - progress) ** 3;
      const current = num * eased;
      setDisplay(`${decimals ? current.toFixed(decimals) : Math.round(current)}${suffix}`);
      if (progress < 1) frame = requestAnimationFrame(step);
    };

    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [active, num, suffix, decimals, value, duration]);

  return display;
};

export default useCountUp;